export const GlobalConfiguration = {
  OVATION_ENABLED: false,
};
